// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calculation-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 2H22V22H2V2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 2H22V22H2V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 8H8M8 8H10M8 8V6M8 8V10M14 8H18M14 14.5H18M14 17.5H18M6.58575 14.5859L7.99981 16M7.99981 16L9.41418 17.4144M7.99981 16L9.41388 14.5859M7.99981 16L6.58545 17.4144","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Calculation1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calculation-1',
    ref,
    icon: element,
  },
));

Calculation1Icon.displayName = 'Calculation1Icon';

export default Calculation1Icon;
